export default {
  currentInfoOverlay: {
    type: null,
    properties: {},
    feature: {},
    event: {},
    isLoading: false,
    isDownloadingPDF: false,
  },
};
